

import Vue from 'vue'
import Transformer from '@/transformers/transformer'
import moment from 'moment'

class SinisterTransformer extends Transformer {
	static fetch({ sinister_id, sinister_road_id, requisition_number,
							  date_assignment, sinister_number, days_in_process, label,
                its_priority, its_urgent }) {
		return {
			id: sinister_road_id,
			sinisterId: sinister_id,
			sinisterNumber: sinister_number,
			// requisitionNumber: requisition_number,
			dateAssignment: date_assignment,
      daysInProcess: days_in_process,
      urgent: its_urgent,
      priority: its_priority,
      label
		}
	}
}

const filtersTransformer = ({ fromDate, toDate, highway }) => ({
    fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined,
    toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : undefined,
    highway: highway && highway.length >= 1
      ? (highway.length === 1 ? (
            highway[0] >= 1 ? highway[0] : undefined
        ) : `(${highway.join(',')})`)
      : undefined
  })

export default (statusId, params = {}) => Vue.$http.get(`/sinisters/extranet_macro_process/${statusId}/`, {
			params: filtersTransformer(params)
		})
		.then((response) => {
      const { avg, advanced = 0, valuation = 0, data, count } = response.data

			return {
        avg,
        count,
        advanced,
        valuation,
        sinisters: SinisterTransformer.fetchCollection(data || [])
      }
		})



// WEBPACK FOOTER //
// ./src/services/sinister/extranetFetchByStatus.js